module.exports = __webpack_public_path__ + "fonts/montserrat-extralightitalic-webfont.3a57691.woff2";